<template>
  <vue-date-picker
    format="M/d/yyyy"
    month-name-format="long"
    text-input
    :year-range="yearRange"
    :clearable="false"
    :offset="4"
    :teleport="true"
    time-picker-inline
    week-start="0"
    :is-24="false"
    :auto-apply="autoApply"
    :enable-time-picker="enableTimePicker"
  >

    <!-- Replace the input field when text-input is enabled -->
    <template #dp-input="{ value, onInput, onEnter, onTab, onClear, onBlur, onKeypress, closeMenu }">
      <div class="relative">
        <u-input
          icon="i-ri-calendar-event-line"
          autocomplete="off"
          :size="size"
          :model-value="value"
          :placeholder="placeholder"
          @keydown.down="onKeypress"
          @keydown.enter="onEnter"
          @keydown.tab="onTab"
          @keydown.esc="closeMenu"
          @blur="onBlur"
          @input="onInput"
        />

        <u-button
          v-if="value"
          class="absolute top-0 right-0"
          :icon="COMMON_ICONS.close"
          :size="size"
          :color="color"
          variant="link"
          @click="onClear"
        />
      </div>
    </template>

    <template #arrow-left>
      <u-icon name="i-ri-arrow-left-s-line" class="text-2xl text-charcoal-400" />
    </template>

    <template #arrow-right>
      <u-icon name="i-ri-arrow-right-s-line" class="text-2xl text-charcoal-400" />
    </template>

    <!-- Replace the menu's header
    <template
      #month-year="{
        month,
        year,
        months,
        years,
        updateMonthYear,
        handleMonthYearChange
      }"
    >

      <div class="w-full">
        <div class="flex justify-between align-middle">
          <div class="flex gap-2">
            <select
              :value="month"
              @change="updateMonth($event, updateMonthYear, year)">

              <option
                v-for="month in months"
                :key="month.value"
                :value="month.value">

                {{ month.text }}
              </option>
            </select>

            <select
              :value="year"
              @change="updateYear($event, updateMonthYear, month)">

              <option
                v-for="year in years"
                :key="year.value"
                :value="year.value">

                {{ year.text }}
              </option>
            </select>
          </div>

          <div class="flex -mt-px">
            <u-button
              icon="i-ri-arrow-left-s-line"
              color="charcoal"
              variant="ghost"
              size="sm"
              @click="handleMonthYearChange(false)"
            />

            <u-button
              icon="i-ri-arrow-right-s-line"
              color="charcoal"
              variant="ghost"
              size="sm"
              @click="handleMonthYearChange(true)"
            />
          </div>
        </div>
      </div>
    </template>
    -->

    <template #action-row="{ closePicker, selectDate }">

        <div class="w-full grid gap-3">
<!--          <u-button
            block
            :icon="COMMON_ICONS.close"
            v-if="showClose"
            label="Cancel"
            size="md"
            @click="closePicker"
            :ui="{variant: {solid: 'dark:text-charcoal dark:bg-gray-200 dark:hover:bg-gray-300'}}"
          />-->
          <u-button
            block
            label="Save"
            icon="i-ri-check-line"
            size="md"
            @click="selectDate"
            :ui="{variant: {solid: 'dark:text-white dark:bg-heroblue dark:hover:bg-heroblue-700'}}"
          />
        </div>


    </template>
  </vue-date-picker>
</template>

<script setup>
  //todo: need a disabled state

  import VueDatePicker from '@vuepic/vue-datepicker';
  import '@vuepic/vue-datepicker/dist/main.css';

  const props = defineProps({
    size: {
      type: String,
      default: 'lg'
    },
    variant: {
      type: String
    },
    color: {
      type: String,
      default: 'white'
    },
    placeholder: {
      type: String,
      default: 'MM/DD/YYYY'
    },
    showClose: {
      type: Boolean,
      default: true
    },
    yearRange: {
      type: Array,
      default: [1500, useDayjs().utc().year() + 1]
    },
    autoApply: {
      type: Boolean,
      default: true
    },
    enableTimePicker: {
      type: Boolean
    }
  });
</script>

<style scoped lang="scss">
//todo move all these out to a separate file in assets
  :global(.dp__menu_inner .dp__instance_calendar:last-child .dp__month_year_row) {
    padding-left: 0;

    @media (min-width: 600px) {
      padding-left: 30px;
    }
  }

  :global(.dp__menu_inner .dp__instance_calendar:last-child .dp__calendar_next) {
    margin-inline-start: 0; /* Space between multiple calendars */

    @media (min-width: 600px) {
      margin-inline-start: 20px; /* Space between multiple calendars */
    }
  }
  :global(.dp__time_col.dp__time_col_reg_with_button) {
    padding: 0 5px;
  }
  :global(.dp__pm_am_button) {
    margin: 0 5px;
  }
  :global(.dp--tp-wrap) {
    padding-bottom: 6px; //note: matches the --dp-menu-padding which is applied to the date selector but not the time one for some reason
  }

</style>

<style>
  .dp__theme_light {
    /* --dp-background-color: #fff; */
    --dp-text-color: theme('colors.charcoal.500');
    --dp-hover-color: theme('colors.shell.400');
    --dp-hover-text-color: theme('colors.charcoal.500');
    /* --dp-hover-icon-color: #959595; */
    --dp-primary-color: theme('colors.primary.500');
    --dp-primary-disabled-color: theme('colors.primary.300');
    --dp-primary-text-color: theme('colors.white');
    /* --dp-secondary-color: #c0c4cc; */
    --dp-border-color: theme('colors.gray.300');
    --dp-menu-border-color: theme('colors.gray.200');
    /* --dp-border-color-hover: #aaaeb7; */
    /* --dp-disabled-color: #f6f6f6; */
    /* --dp-scroll-bar-background: #f3f3f3; */
    /* --dp-scroll-bar-color: #959595; */
    /* --dp-success-color: #76d275; */
    /* --dp-success-color: #76d275; */
    /* --dp-success-color-disabled: #a3d9b1; */
    --dp-icon-color: theme('colors.gray.300');
    /* --dp-danger-color: #ff6f60; */
    /* --dp-marker-color: #ff6f60; */
    /* --dp-tooltip-color: #fafafa; */
    /* --dp-disabled-color-text: #8e8e8e; */
    /* --dp-highlight-color: rgb(25 118 210 / 10%); */
    --dp-range-between-dates-background-color: theme('colors.shell.400');
    /* --dp-range-between-dates-text-color: var(--dp-hover-text-color, #212121); */
    /* --dp-range-between-border-color: var(--dp-hover-color, #f3f3f3); */
    --dp-range-between-border-color: theme('colors.shell.200');
  }

  :root {
    /*General*/
    --dp-font-family: unset;
    --dp-border-radius: 2px; /*Configurable border-radius*/
    --dp-cell-border-radius: 4px; /*Specific border radius for the calendar cell*/
    --dp-common-transition: all 0.1s ease-in; /*Generic transition applied on buttons and calendar cells*/

    /*Sizing*/
    --dp-button-height: 30px; /* Size for buttons in overlays */
    --dp-button-icon-height: 20px; /* Icon sizing in buttons */
    --dp-cell-size: 30px; /* Width and height of calendar cell */
    --dp-cell-padding: 5px; /* Padding in the cell */
    --dp-input-padding: 0.375rem 30px 0.375rem 12px; /* Padding in the input */
    /*--dp-menu-min-width: 26px;*/ /* Adjust the min width of the menu */
    --dp-menu-padding: 6px 4px; /* Menu padding */
    --dp-row-margin: 2px 0; /* Adjust the spacing between rows in the calendar */
    --dp-calendar-header-cell-padding:  0.5rem; /* Adjust padding in calendar header cells */
    --dp-overlay-col-padding: 0px; /* Padding in the overlay column */

    /*Font sizes*/
    --dp-font-size: 0.9rem; /*Default font-size*/
  }
</style>
